import React, { useState, useEffect } from "react";
import { AiOutlineMenuFold } from "react-icons/ai";
import { IoExitOutline } from "react-icons/io5";
import { Link, NavLink } from "react-router-dom";
import { BsInstagram } from "react-icons/bs";
import { FaXTwitter, FaWhatsapp } from "react-icons/fa6";
import { WiMoonAltThirdQuarter } from "react-icons/wi";
import LanguageDropdown from "./LanguageDropdown";

const Header = ({ themeChange, theme }) => {
  const [mobileMenu, setMobileMenu] = useState(false);

  const changeLanguage = (langCode) => {
    const select = document.querySelector("#google_translate_element2 select");
    if (!select) {
      console.warn("Google Translate select element not found");
      return;
    }
    select.value = langCode;

    const event = new Event("change", { bubbles: true });
    select.dispatchEvent(event);
  };

  useEffect(() => {
    if (document.getElementById("google-translate-script")) return;

    window.googleTranslateElementInit2 = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "tr",
            autoDisplay: true,
          },
          "google_translate_element2"
        );
      }
    };

    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2";
    script.async = true;

    script.onerror = () => {
      console.error("Google Translate script failed to load.");
    };

    document.body.appendChild(script);

    return () => {
      // Sadece callback’i temizle, script’i kaldırma.
      delete window.googleTranslateElementInit2;
    };
  }, []);

  return (
    <div
      className={`rounded-md lg:mb-12 mt-3 ${
        mobileMenu ? "h-56 justify-start pt-2" : "h-14 justify-center"
      } xl:mx-20 lg:mx-16 md:mx-10 sm:mx-0 z-20 flex flex-col items-center ${
        theme ? "text-white" : ""
      }`}
    >
      {/* Google Translate widget container */}
      <div id="google_translate_element2"></div>

      <div className="container flex flex-row justify-between pr-5 lg:px-10 w-full">
        <NavLink to={"/"}>
          <img
            className="lg:w-[300px] w-[200px]"
            src={theme ? "/img/logofooter.png" : "/img/fuatyaz.png"}
            alt="Logo"
          />
        </NavLink>

        <nav className="text-lg font-semibold hidden lg:flex lg:flex-row justify-center items-center">
          <NavLink
            to={"/"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Anasayfa
          </NavLink>
          <NavLink
            to={"/hakkimizda"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Hakkımızda
          </NavLink>
          <NavLink
            to={"/yatirim"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Yatırım
          </NavLink>
          <NavLink
            to={"/iletisim"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            İletişim
          </NavLink>
        </nav>

        <div className="text-lg font-semibold hidden lg:flex lg:flex-row justify-center items-center">
          <a
            href="https://www.instagram.com/fuatayazgroup/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsInstagram className="mx-2 w-10 h-6" />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=905321349003"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="mx-2 w-10 h-6" />
          </a>
          <a
            href="https://www.twitter.com/fuatayazgroup/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter className="mx-2 w-10 h-6" />
          </a>
          <div
            className="cursor-pointer"
            onClick={() => themeChange(!theme)}
            aria-label="Toggle theme"
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === "Enter" || e.key === " ") themeChange(!theme);
            }}
          >
            <WiMoonAltThirdQuarter className="mx-2 w-10 h-8" />
          </div>
        </div>

        <div className="text-3xl visible lg:invisible cursor-pointer">
          {mobileMenu ? (
            <IoExitOutline onClick={() => setMobileMenu(false)} />
          ) : (
            <AiOutlineMenuFold onClick={() => setMobileMenu(true)} />
          )}
        </div>

        <LanguageDropdown changeLanguage={changeLanguage} />
      </div>

      {mobileMenu && (
        <div className="container z-40 flex flex-col mt-1 justify-between items-center text-xl px-10 w-full">
          <NavLink
            to={"/"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Anasayfa
          </NavLink>
          <NavLink
            to={"/hakkimizda"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Hakkımızda
          </NavLink>
          <NavLink
            to={"/yatirim/al"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Yatırım İsteyin
          </NavLink>
          <NavLink
            to={"/yatirim/yap"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            Yatırım Yapın
          </NavLink>
          <NavLink
            to={"/iletisim"}
            className="px-4 hover:bg-slate-200 hover:rounded-xl"
          >
            İletişim
          </NavLink>
          <LanguageDropdown changeLanguage={changeLanguage} />
        </div>
      )}
    </div>
  );
};

export default Header;
